import * as React from 'react';
import { withStyles, WithStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import SplitPane from 'react-split-pane';
import {
    FMContainer,
    FMToolbar,
    FMFilterInput,
} from 'atoms';
import {
    FMLoading,
} from 'molecules';
import {
    DevicesInfo,
    DeviceInfo,
    FMDevicesListPane,
    FMDeviceInfoPane,
} from 'features/FMDevicesInfo';
import style from './DevicesInfoPage.style';

type Props = WithStyles;

interface State {
    devicesLoaded: boolean;
    devicesInfo: DevicesInfo;
    filteredData: DevicesInfo;
    selectedDevice: DeviceInfo;
}

class DevicesInfoPage extends React.Component<Props, State> {

    public constructor(props: Props) {
        super(props);

        this.state = {
            devicesLoaded: false,
            devicesInfo: null,
            filteredData: null,
            selectedDevice: null,
        };
    }

    public componentDidMount() {
        fetchDevicesInfo(this.setData)
            .catch(error => {
                console.error(error);
                alert(fmtools.translate('api_request_error'));
            });
    }

    private setData = (data: DevicesInfo) =>
        this.setState({
            devicesLoaded: true,
            devicesInfo: data,
            filteredData: data
        })

    private setSelectedDevice = (data: DeviceInfo) => this.setState({ selectedDevice: data });

    private filterData = (text: string) => {
        if (typeof text !== 'string' || text.length < 1) {
            this.setState({ filteredData: this.state.devicesInfo });
            return;
        }

        let newGroups = [];
        let lowerText = text.toLowerCase();
        for (let group of this.state.devicesInfo.groups) {
            let devices = [];
            for (let device of group.devices) {
                if (this.isNamePassFilter(device.name, lowerText)) {
                    devices.push(device);
                }
            }
            if (devices.length > 0) {
                newGroups.push({
                    name: group.name,
                    devices,
                });
            }
        }

        this.setState({ filteredData: { groups: newGroups, sensorCaptions: null } });
    }

    private isNamePassFilter = (name: string, text: string) => name.toLowerCase().indexOf(text) !== -1;

    public render() {
        let selectedDeviceName = this.state.selectedDevice ? this.state.selectedDevice.name : '';

        return (
            <FMContainer square={true} className={this.props.classes.pageContainer}>
                <FMContainer square={true} className={this.props.classes.pageCaption}>
                    <img src="../img/fmlogo_new.png" style={{ marginRight: 25 }} />
                    <Typography variant="h5">{fmtools.translate('DevicesInfoPageCaption')}</Typography>
                </FMContainer>
                <FMContainer className={this.props.classes.pageContent}>
                    <SplitPane
                        split="vertical"
                        defaultSize="400px"
                        minSize={250}
                        maxSize={-200}
                        className={this.props.classes.splitPane}
                    >
                        <FMContainer square={true} className={this.props.classes.devicesListPane}>
                            <FMToolbar variant="dense">
                                <FMFilterInput
                                    placeholder={fmtools.translate('FilterDevices')}
                                    filter={this.filterData}
                                />
                            </FMToolbar>
                            {
                                !this.state.devicesLoaded &&
                                <FMLoading />
                            }
                            {
                                this.state.devicesLoaded &&
                                    <FMContainer square={true} className={this.props.classes.devicesList}>
                                        <FMDevicesListPane
                                            devicesInfo={this.state.filteredData}
                                            selectedDeviceName={selectedDeviceName}
                                            onItemClick={this.setSelectedDevice}
                                        />
                                    </FMContainer>
                            }
                        </FMContainer>
                        <FMDeviceInfoPane
                            deviceInfo={this.state.selectedDevice}
                            sensorCaptions={this.state.devicesInfo ? this.state.devicesInfo.sensorCaptions : []}
                        />
                    </SplitPane>
                </FMContainer>
            </FMContainer>
        );
    }

}

const fetchDevicesInfo = async setData =>
    fetch('../api/v2/devicesinfo')
        .then(async response => response.json())
        .then(setData);

export default withStyles(style)(DevicesInfoPage);
